import { useEffect } from "react";

// Add a script tag to the page as a react effect.
// This effect doesn't clean up after itself
export function useScriptTag(src: string) {
  return useEffect(() => {
    const foundScript = document.querySelector(`script[src="${src}"]`);

    if (!foundScript) {
      // You have to do this document.createElement dance. If you try to
      // add a script parsed from a string, such as by element.innerHTML =
      // `<script src="..." />`, the browser won't load it, because that's
      // a cross-site scripting attack vector.
      const script = document.createElement("script");
      script.type = "application/javascript";
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
  }, [src]);
}
